import { Injectable } from '@angular/core';
import { CommonService } from '../../commons/services/common.service';

@Injectable()
export class GestionSygetrack {
    /**
     * A chaque création/modification de chantier sur Ecobennes, un POI doit être créé dans Sygetrack
     */
    public static setPOI(id, common: CommonService) {
        const param = {
            'servlet': 'DBGestionSygetrack',
            'module': 'Recylog',
            'type': 'map',
            'compression': 'false',
            'data': {
                'OPERATION': {
                  'typeParam': 'int',
                  'valeur': 10
                },          
                'CLEF_CHANTIER': {
                  'typeParam': 'int',
                  'valeur': id
                },
                'CLEF_SITE': {
                  'typeParam': 'int',
                  'valeur': common.user[2]
                }
            }
        };

        return common.post('', { param: param });
    }       
    
    /**
     * A chaque création/modification paramétrage contenant => une synchro doit être créé dans Sygetrack
     */
    public static setMateriel(id, common: CommonService) {
        const param = {
            'servlet': 'DBGestionSygetrack',
            'module': 'Recylog',
            'type': 'map',
            'compression': 'false',
            'data': {
                'OPERATION': {
                  'typeParam': 'int',
                  'valeur': 11
                },          
                'CLEF_BENNE': {
                  'typeParam': 'int',
                  'valeur': id
                },
                'CLEF_SITE': {
                  'typeParam': 'int',
                  'valeur': common.user[2]
                }
            }
        };

        return common.post('', { param: param });
    }           
    
    /**
     * A chaque création/modification planning chauffeur => une synchro doit être créé dans Sygetrack
     */
    public static setPlanifDI(resourceOldForSygetrack, resourceNewForSygetrack, common: CommonService, showSpinner?) {
        const param = {
            'servlet': 'DBGestionSygetrack',
            'module': 'Recylog',
            'type': 'map',
            'compression': 'false',
            'data': {
                'OPERATION': {
                  'typeParam': 'int',
                  'valeur': 12
                },
                'CLEF_SITE': {
                  'typeParam': 'int',
                  'valeur': common.user[2]
                }
            }
        };
        
        if(resourceOldForSygetrack && resourceOldForSygetrack['idChauff']) {
            param['data']['CLEF_CHAUFFEUR_OLD'] = {
                'typeParam': 'int',
                'valeur': resourceOldForSygetrack['idChauff'] || 0
            }
            param['data']['CLEF_PERIODE_OLD'] = {
                'typeParam': 'int',
                'valeur': resourceOldForSygetrack['periodeId'] || 0
            }
            param['data']['DATE_OLD'] = {
                'typeParam': 'date',
                'valeur': resourceOldForSygetrack['dateSygetrack'] || 0
            }
            param['data']['CLEF_CAMION_OLD'] = {
                'typeParam': 'int',
                'valeur': resourceOldForSygetrack['idCamion'] || 0
            }            
        }
        
        if(resourceNewForSygetrack) {
            param['data']['CLEF_CHAUFFEUR_NEW'] = {
                'typeParam': 'int',
                'valeur':  resourceNewForSygetrack['idChauff'] || 0
            }
            param['data']['CLEF_PERIODE_NEW'] = {
                'typeParam': 'int',
                'valeur': resourceNewForSygetrack['periodeId'] || 0
            } 
            param['data']['DATE_NEW'] = {
                'typeParam': 'date',
                'valeur':  resourceNewForSygetrack['dateSygetrack'] || 0
            } 
            param['data']['CLEF_CAMION_NEW'] = {
                'typeParam': 'int',
                'valeur': resourceNewForSygetrack['idCamion'] || 0
            }                        
        }        

        return common.post('', { param: param }, showSpinner|| false);
    }
    
    /**
     * A chaque création/modification planning chauffeur => une synchro doit être créé dans CLS
     */
    public static setPlanifDICLS(resourceOldForSygetrack, resourceNewForSygetrack, common: CommonService, showSpinner?, pasMessage?) {
        const param = {
            'servlet': 'DBGestionCLS',
            'module': 'Recylog',
            'type': 'map',
            'compression': 'false',
            'data': {
                'OPERATION': {
                  'typeParam': 'int',
                  'valeur': 1
                },
                'CLEF_SITE': {
                  'typeParam': 'int',
                  'valeur': common.user[2]
                }
            }
        };
        
        if(resourceOldForSygetrack && resourceOldForSygetrack['idChauff']) {
            param['data']['CLEF_CHAUFFEUR_OLD'] = {
                'typeParam': 'int',
                'valeur': resourceOldForSygetrack['idChauff'] || 0
            }
            param['data']['CLEF_PERIODE_OLD'] = {
                'typeParam': 'int',
                'valeur': resourceOldForSygetrack['periodeId'] || 0
            }
            param['data']['DATE_OLD'] = {
                'typeParam': 'date',
                'valeur': resourceOldForSygetrack['dateSygetrack'] || 0
            }
            param['data']['CLEF_CAMION_OLD'] = {
                'typeParam': 'int',
                'valeur': resourceOldForSygetrack['idCamion'] || 0
            }            
        }
        
        if(resourceNewForSygetrack) {
            param['data']['CLEF_CHAUFFEUR_NEW'] = {
                'typeParam': 'int',
                'valeur':  resourceNewForSygetrack['idChauff'] || 0
            }
            param['data']['CLEF_PERIODE_NEW'] = {
                'typeParam': 'int',
                'valeur': resourceNewForSygetrack['periodeId'] || 0
            } 
            param['data']['DATE_NEW'] = {
                'typeParam': 'date',
                'valeur':  resourceNewForSygetrack['dateSygetrack'] || 0
            } 
            param['data']['CLEF_CAMION_NEW'] = {
                'typeParam': 'int',
                'valeur': resourceNewForSygetrack['idCamion'] || 0
            }                        
        }        

        return common.post('', { param: param }, showSpinner|| false, pasMessage || false);
    }  
    
    /**
     * Récupération des circuits Sygetrack
     */
    public static getCircuits(common: CommonService) {
        const param = {
            'servlet': 'DBGestionSygetrack',
            'module': 'Recylog',
            'type': 'map',
            'compression': 'false',
            'data': {
                'OPERATION': {
                  'typeParam': 'int',
                  'valeur': 13
                },
                'CLEF_SITE': {
                  'typeParam': 'int',
                  'valeur': common.user[2]
                }
            }
        };

        return common.post('', { param: param });
    }           
    
    /**
     * Positionner code externe
     */
    public static positionnerCodeExterne(circuits, common: CommonService) {
        const param = {
            'servlet': 'DBGestionSygetrack',
            'module': 'Recylog',
            'type': 'map',
            'compression': 'false',
            'data': {
                'OPERATION': {
                  'typeParam': 'int',
                  'valeur': 5
                },
                'CLEF_SITE': {
                  'typeParam': 'int',
                  'valeur': common.user[2]
                },
                'LIST_CIRCUIT': circuits
            }
        };

        return common.post('', { param: param }, true);
    }            
    
    /**
     * Envoyer prestation vers sygetrack
     */
    public static setPlannification(locationMateriel, withRollback, common: CommonService) {
        console.log(locationMateriel);
        const sygetrack_date_debut = locationMateriel['dateDebut'] + '%20' + locationMateriel['heureDebut'];
        const sygetrack_date_fin = locationMateriel['dateFin'] + '%20' + locationMateriel['heureFin'];
        const sygetrack_bon_numero = locationMateriel['bon'].numBon;
        const sygetrack_chauffeur_matricule = locationMateriel['chauffeur'] && locationMateriel['chauffeur'].matricule ? 
            locationMateriel['chauffeur'].matricule : '';
        const sygetrack_chantier_codeexterne = locationMateriel['chantier'].codeExterne;
        
        const camion = locationMateriel['camion'];
        const immatriculationCamion = camion.immatriculation || '';
        const sygetrack_camion_immatricule = camion.numParc ? camion.numParc + '%2F' + immatriculationCamion : immatriculationCamion;
        let compteurEquipier = 1;
        let matriculeEquipier1 = '';
        let matriculeEquipier2 = '';
        if(locationMateriel.listePersonnelParPoste && locationMateriel.listePersonnelParPoste.length) {
            locationMateriel.listePersonnelParPoste.forEach(o => {
                if(compteurEquipier <= 2 && o.poste && !o.poste.posteDesactiveParDefault &&
                    o.chauffeur && o.chauffeur.matricule) {
                    switch(compteurEquipier) {
                        case 1 :
                            matriculeEquipier1 = o.chauffeur.matricule;
                            break;
                        case 2 :
                            matriculeEquipier2 = o.chauffeur.matricule;
                            break;                                
                    }
                    
                    compteurEquipier++;
                }
            });
        }
        
        const consigne = locationMateriel['infosSup'] || '';
        const nomChantier = locationMateriel['chantier'].numChantier || '';
        const logSygetrack = {
            nomclass : 'LogSygetrack',
            clefLocationMateriel: locationMateriel.id || 0,
            clefCamion: locationMateriel.camion && locationMateriel.camion.id ? locationMateriel.camion.id : 0,
            clefChauffeur: locationMateriel.chauffeur && locationMateriel.chauffeur.id ? locationMateriel.chauffeur.id : 0,
            clefChantier: locationMateriel.chantier && locationMateriel.chantier.id ? locationMateriel.chantier.id : 0,
            agent1: matriculeEquipier1,
            agent2: matriculeEquipier2,
            consigne: consigne,
            chantier: nomChantier
        }
        
        const param = {
            'servlet': 'DBGestionSygetrack',
            'module': 'Recylog',
            'type': 'map',
            'compression': 'false',
            'data': {
                'OPERATION': {
                  'typeParam': 'int',
                  'valeur': 6
                },
                'CLEF_LOCATION': {
                  'typeParam': 'int',
                  'valeur': locationMateriel.id
                },                
                'DEBUT': sygetrack_date_debut,
                'FIN': sygetrack_date_fin,
                'CODE': sygetrack_bon_numero,
                'CHAUFFEUR': sygetrack_chauffeur_matricule,
                'VEHICULE': sygetrack_camion_immatricule,
                'CIRCUIT': sygetrack_chantier_codeexterne,
                'DESCRIPTION': sygetrack_bon_numero,
                'AGENT1': matriculeEquipier1,
                'AGENT2': matriculeEquipier2,
                'CONSIGNE': consigne,
                'NOM_CHANTIER': nomChantier,
                'LOGSYGETRACK': logSygetrack,
                'IS_ANGULAR': {
                  'typeParam': 'boolean',
                  'valeur': true
                },
                'CLEF_SITE': {
                  'typeParam': 'int',
                  'valeur': common.user[2]
                }
            }
        };

        return common.post('', { param: param }, true);
    }           
    
    /**
     * Supprimer plannification ecoloc
     */
    public static delPlannification(code, clefLocation, common: CommonService) {
        const param = {
            'servlet': 'DBGestionSygetrack',
            'module': 'Recylog',
            'type': 'map',
            'compression': 'false',
            'data': {
                'OPERATION': {
                  'typeParam': 'int',
                  'valeur': 7
                },
                'CLEF_LOCATION': {
                  'typeParam': 'int',
                  'valeur': clefLocation
                },                
                'IS_ANGULAR': {
                  'typeParam': 'boolean',
                  'valeur': true
                },
                'CODE' : code || '',
                'CLEF_SITE': {
                  'typeParam': 'int',
                  'valeur': common.user[2]
                }
            }
        };

        return common.post('', { param: param }, true);
    }            
    
    /**
     * Rollback location materiel
     */
    public static rollbackLocationMateriel(locationMateriel, common: CommonService) {
        locationMateriel['nomclass'] = 'LocationMateriel';
        const param = {
            'servlet': 'DBGestionSygetrack',
            'module': 'Recylog',
            'type': 'map',
            'compression': 'false',
            'data': {
                'OPERATION': {
                  'typeParam': 'int',
                  'valeur': 9
                },
                'LOCATION_MATERIEL' : locationMateriel,
                'CLEF_SITE': {
                  'typeParam': 'int',
                  'valeur': common.user[2]
                }
            }
        };

        return common.post('', { param: param }, true);
    }       
    
    public static getNomInformatiqueEmbarque(common: CommonService) {
        const param = {
            'servlet': 'DBGestionSygetrack',
            'module': 'Recylog',
            'type': 'map',
            'compression': 'false',
            'data': {
                'OPERATION': {
                  'typeParam': 'int',
                  'valeur': 14
                },
                'CLEF_SITE': {
                  'typeParam': 'int',
                  'valeur': common.user[2]
                }
            }
        };

        return common.post('', { param: param }, true);
    }  
    
  public static setPlannificationEnMasse(locationMaterielList: any, common: CommonService) {
    let locationMaterielListMapped = this.mappedLocationMateriel(locationMaterielList);
    const param = {
      'servlet': 'DBGestionSygetrack',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 15
        },
        'CLEF_SITE': {
          typeParam: 'int',
          valeur: common.user[2]
        },
        'IS_ANGULAR': {
          typeParam: 'boolean',
          valeur: true
        },
       'LIST_LOCATIONS': locationMaterielListMapped
      }
    };


   return common.post('', { param: param }, true);
  }

  public static mappedLocationMateriel(locationMaterielList: any[]) {
    const locationMaterielListMapped = [];
    locationMaterielList.forEach(locationMateriel => {
      const sygetrack_date_debut =locationMateriel.dateDebut + '%20' + locationMateriel.heureDebut;
      const sygetrack_date_fin =locationMateriel.dateFin + '%20' + locationMateriel.heureFin;
      const sygetrack_bon_numero = locationMateriel.bon?.numBon || '';
      const sygetrack_chauffeur_matricule = locationMateriel.chauffeur?.matricule || '';
      const sygetrack_chantier_codeexterne =locationMateriel.chantier?.codeExterne || '';
      const camion = locationMateriel.camion || {};
      const immatriculationCamion = camion.immatriculation || '';
      const sygetrack_camion_immatricule = camion.numParc ? camion.numParc + '%2F' + immatriculationCamion : immatriculationCamion;
      // 👷 Équipiers
      let compteurEquipier = 1;
      let matriculeEquipier1 = '';
      let matriculeEquipier2 = '';

      if (locationMateriel.listePersonnelParPoste?.length) {
        locationMateriel.listePersonnelParPoste.forEach(o => {
          if (
            compteurEquipier <= 2 &&
            o.poste &&
            !o.poste.posteDesactiveParDefault &&
            o.chauffeur?.matricule
          ) {
            if (compteurEquipier === 1) matriculeEquipier1 = o.chauffeur.matricule;
            if (compteurEquipier === 2) matriculeEquipier2 = o.chauffeur.matricule;
            compteurEquipier++;
          }
        });
      }

      const consigne = locationMateriel.infosSup || '';
      const nomChantier = locationMateriel.chantier?.numChantier || '';

      const logSygetrack = {
        nomclass: 'LogSygetrack',
        clefLocationMateriel: locationMateriel.id || 0,
        clefCamion: locationMateriel.camion?.id || 0,
        clefChauffeur: locationMateriel.chauffeur?.id || 0,
        clefChantier: locationMateriel.chantier?.id || 0,
        agent1: matriculeEquipier1,
        agent2: matriculeEquipier2,
        consigne: consigne,
        chantier: nomChantier
      };

      locationMaterielListMapped.push({
        'clefLocation': {
          typeParam: 'int',
          valeur: locationMateriel.id
        },
        'debut': sygetrack_date_debut,
        'fin': sygetrack_date_fin,
        'code': sygetrack_bon_numero,
        'chauffeur': sygetrack_chauffeur_matricule,
        'vehicule': sygetrack_camion_immatricule,
        'circuit': sygetrack_chantier_codeexterne,
        'description': sygetrack_bon_numero,
        'agent1': matriculeEquipier1,
        'agent2': matriculeEquipier2,
        'consigne': consigne,
        'nomChantier': nomChantier,
        'LogSygetrack': logSygetrack,
        'nomclass': 'ParamEnvoiEcolocSygetrack'
      });
    });
    return locationMaterielListMapped;
  }
} 
